// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Preact from "../bindings/Preact.js";
import * as JsxRuntime from "react/jsx-runtime";

function Admin(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: "Admin Panel",
            className: "page-title"
          }),
          JsxRuntime.jsx("p", {
            children: `Admin: ` + props.adminId,
            className: "page-subtitle"
          })
        ],
        className: "page-header"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("p", {
          children: "Admin panel - coming soon",
          className: "text-center"
        }),
        className: "container"
      })
    ],
    className: "page",
    "data-testid": "admin-page"
  });
}

function expose() {
  Preact.setWindowProperty("Admin", Admin);
}

let make = Admin;

export {
  make,
  expose,
}
/* react/jsx-runtime Not a pure module */
